import IndividualTable from '../../../IndividualTable';
import { sampleData } from "../../sampleData";

const Distance145 = () => {
  return <IndividualTable matchType={"PRE"} gender="M" event="145" subTitle="Kungdo" data={sampleData} topRankCount="16" />;
};
export default Distance145;
